import { blue, green, grey } from "@material-ui/core/colors";
import { workNestPalette } from "./constants";

const darkVariant = {
  name: "Dark",
  palette: {
    primary: {
      main: workNestPalette.primary,
      contrastText: "#FFFFFF"
    },
    secondary: {
      main: workNestPalette.secondary,
      light: "#d6eef7",
      contrastText: "#FFFFFF"
    },
    teal: {
      main: "#216869",
      contrastText: "#FFF"
    }
  },
  header: {
    color: grey[500],
    background: "#FFFFFF",
    search: {
      color: grey[800]
    },
    indicator: {
      background: blue[600]
    }
  },
  sidebar: {
    color: 'black',
    background: 'white',
    header: {
      color: grey[200],
      background: workNestPalette.primary,
      brand: {
        color: workNestPalette.primary
      }
    },
    footer: {
      color: 'black',
      background: workNestPalette.primary,
      online: {
        background: green[500]
      }
    },
    category: {
      fontWeight: 400
    },
    badge: {
      color: "#FFF",
      background: blue[500]
    }
  },
  body: {
    background: "#F7F9FC"
  },
  section: {
    background: green[500]
  }
};

const variants = [
  darkVariant,
];

export default variants;
